import { combineReducers } from 'redux';

import generalOprs from './generalOprs';
import categoryOprs from './categoryOprs';
import questionOprs from './questionOprs';

// =============================================
// Reducer at the root level of the oprs branch:
// =============================================
const faqsOprs = combineReducers({ generalOprs, categoryOprs, questionOprs });

// eslint-disable-next-line import/no-default-export -- FIXME: Convert to a named export https://github.com/wegotpop/popsss/wiki/Imports#default-exports
export default faqsOprs;
